import './requiredCheckboxes.scss'

/**
 * Required Checkboxes directive
 *
 * Sets the containing form as valid only if at least one of the values of
 * the group of models passed in ng-model is true. Use the name attribute to
 * add the fake model to the form controller.
 *
 * @example
 * <!-- Validate at myFormController.checkboxes.$error -->
 * <md-input-container tmr-required-checkboxes ng-model="$ctrl.checkboxesModels" name="checkboxes">
 *   <md-checkbox></md-checkbox>
 * </md-input-container>
 * <input type="checkbox" ng-model="$ctrl.checkboxesModels.cb1">
 * <input type="checkbox" ng-model="$ctrl.checkboxesModels.cb2">
 *
 * @example <caption>Required only if $ctrl.isRequired is true</caption>
 * <div tmr-required-checkboxes="$ctrl.isRequired" ng-model="$ctrl.checkboxesModels" name="checkboxes"></div>
 *
 * @namespace
 * @alias tmrRequiredCheckboxes
 * @type {ngDirective}
 */
function tmrRequiredCheckboxesDirective($parse) {
  'ngInject'
  return {
    require: 'ngModel',
    link,
  }

  function link(scope, elm, attrs, ctrl) {
    function setValidity(isRequired, values) {
      ctrl.$setValidity(
        'tmrRequiredCheckboxes',
        !isRequired || Object.values(values).indexOf(true) > -1
      )
    }

    scope.$watch(attrs.tmrRequiredCheckboxes, values =>
      setValidity(values, $parse(attrs.ngModel)(scope))
    )

    scope.$watchCollection(attrs.ngModel, (values, prevValues) => {
      let isRequired = $parse(attrs.tmrRequiredCheckboxes)(scope) ?? true
      setValidity(isRequired, values)
      if (values != prevValues) ctrl.$setDirty()
    })
  }
}

export const directive = [
  'tmrRequiredCheckboxes',
  tmrRequiredCheckboxesDirective,
]
